import React, { useEffect } from 'react'
import { parse } from 'querystring'
import { useLocation, withRouter } from 'react-router-dom'
import { RouteComponentProps, useHistory } from 'react-router'

export type BaseSocialApplication = {
    serviceName: string,
    oauthProps: {
        code?: string,
        access_token?: string
    }
}

import { loginWithSocialAsync } from 'actions/auth-actions';

interface RedictComponentProps {
    fetching: boolean,
    serviceName: string,
    redirectToLogin: boolean,
    onLogin: typeof loginWithSocialAsync
}

function RedirectComponent(props: RedictComponentProps & RouteComponentProps): JSX.Element {
    const {
        fetching,
        redirectToLogin,
        serviceName,
        onLogin
    } = props;
    const location = useLocation()
    const history = useHistory()
    useEffect(() => {
        const queryString = location.search.substring(1)
        const { code, access_token } = parse(queryString)
        console.debug({ code, access_token })
        const socialApplication: BaseSocialApplication = {
            serviceName,
            oauthProps: {
                code: typeof code === 'object' ? code[0] : code,
                access_token: typeof access_token === 'object' ? access_token[0] : access_token,
            }
        }
        onLogin(socialApplication)
    }, [null])
    useEffect(() => {
        if (!redirectToLogin) return
        history.push('/auth/login')
    }, [redirectToLogin])
    return <div>Redirecting by {serviceName} Auth</div>
}

export default withRouter(RedirectComponent)
